import React, { useState, useEffect } from "react";
import "../../styles/components-styles/question-components-styles/QuestionBody-style.css";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import QuestionDropDown from "./QuestionDropDown";
import { Hammer } from "lucide-react";
import RecentSessions from "./RecentSessions";
import axios from "axios";

function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
        console.log("totally custom!")
    );

    return (
        <button type="button" onClick={decoratedOnClick}>
            {children}
        </button>
    );
}

let userId = sessionStorage.getItem("userId");

const QuestionBody = () => {
    const [categoryStats, setCategoryStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCategoryStats = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await axios.get(`/user/category-stats/${userId}`); // Adjust the API endpoint if needed
                if (response.status === 200) {
                  setCategoryStats(response.data.categoryStats);
                }
            } catch (err) {
                console.error("Error fetching category stats:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchCategoryStats();
        }
    }, [userId]);

    if (loading) {
        return <div>Loading category statistics...</div>;
    }

    if (error) {
        return <div>Error loading category statistics: {error}</div>;
    }

    return (
        <div className="container">
            <div className="cat-row">
                <div className="catergories">
                    <h5>Categories</h5>
                    <hr />
                    <ul>
                        <li className="Qlist-items">
                            <p>
                                <input type="checkbox" name="" id="" />
                                All
                            </p>
                            {categoryStats.reduce((acc, stat) => acc + stat.attemptedQuestions, 0)} of {categoryStats.reduce((acc, stat) => acc + stat.totalQuestions, 0)}
                        </li>
                        {categoryStats.map((stat) => (
                            <li key={stat.category} className="Qlist-items">
                                <p>
                                    <input type="checkbox" name="" id="" />
                                    {stat.category}
                                </p>
                                <p>Attempted {stat.attemptedQuestions} of {stat.totalQuestions}</p>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* ... (rest of your component) */}
            </div>
            <div className="recent-sessions">
                <RecentSessions
                    userId={userId}
                />
            </div>
        </div>
    );
};

export default QuestionBody;